import { 
    SET_LOADING,
    SET_ROLE_TYPE_LIST,
} from "../../actions/roleType/types";

const INITIAL_STATE = {
    loading: false,
    roleTypeList: [],
}

const RoleTypeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ROLE_TYPE_LIST: {
            return {
                ...state,
                roleTypeList : action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default RoleTypeReducer;